module.exports = __webpack_public_path__ + "img/foot_weibo.423de95c.png";